import apiClient from "../../../network/apiClient";

export const fetchGlobalMenuAPI = () => apiClient.get("/menuTemplate/getAll", { handle404Silently: true })
export const addGlobalMenuAPI = ( body ) => apiClient.post("/menuTemplate/create", body)